import { FieldError } from "react-hook-form"
interface Props {
  label: string
  name: string
  register: any
  required: boolean | string
  maxLength: {
    value: number
    message: string
  }
  minLength: {
    value: number
    message: string
  }
  pattern: {
    value: RegExp
    message: string
  }
  password: boolean
  autoComplete: string
  placeholder: string
  icon: any
  errors: FieldError | undefined
}

export const Input = (props: Props) => {
  return (
    <>
      <div className="flex items-center" style={{ marginBottom: 6 }}>
        <label htmlFor={props.name} className="block text-sm font-bold text-gray-800">
          {props.label}
        </label>
        {props.required &&
        <span className="ml-2 text-xs font-extrabold rounded px-1.5 py-0.5" style={{ color: "#FF4D2D", background: "#FFE9E1" }}>
          必須
        </span>
        }
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          {props.icon}
        </div>
        <input
          className="h-11 px-2 focus:ring-[#FF4D2D] focus:border-[#FF4D2D] block w-full pl-10 sm:text-sm border-gray-200 rounded-xl"
          {
          ...props.register(props.name, {
            required: props.required,
            maxLength: { value: props.maxLength.value, message: props.maxLength.message },
            minLength: { value: props.minLength.value, message: props.minLength.message },
            pattern: {
              value: props.pattern.value,
              message: props.pattern.message,
            }
          })
          }
          type={props.password ? "password" : "text"}
          id={props.name}
          autoComplete={props.autoComplete}
          placeholder={props.placeholder}
        />
      </div>
      {props.errors && <p className="text-red-600 text-xs">{props.errors.message}</p>}
    </>
  )
}